import styled from 'styled-components';

import { FloatingLabelTextArea } from 'components/floating-label-fields';

export const StyledFloatingLabelTextArea = styled(FloatingLabelTextArea)`
  & > textarea {
    line-height: 1.5;
    padding-block: 1rem;
    padding-inline-start: 1rem;
    padding-inline-end: 2rem;
    min-height: auto;
  }
`;
